import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Location, NgIf, NgClass } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MatButtonModule } from '@angular/material/button';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-mark-fundraiser-fraudulent',
    templateUrl: './mark-fundraiser-fraudulent.component.html',
    styleUrls: ['./mark-fundraiser-fraudulent.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgClass, ExtendedModule, FlexModule, MatFormFieldModule, MatInputModule, TextFieldModule, MatButtonModule]
})
export class MarkFundraiserFraudulentComponent implements OnInit {
	isLoading: boolean = false;
	fraudulentFurndraiserForm: any;
	marked: boolean = false;
	reported: boolean = false;
	slug = '';
	fradulentFullname = $localize`:@@fraudulent_full_name_Input:Full name`;
	fradulentEmail = $localize`:@@fraudulent_Email_Input:Email Address`;
	fradulentReason = $localize`:@@fraudulent_Reason_Input:Describe the reason`;

	constructor(
		public activatedRoute: ActivatedRoute,
		private _router: Router,
		public fundraiserService: FundraiserService
	) {
		this.slug = this.activatedRoute.snapshot.url[1].path.split(';')[0];
	}

	ngOnInit() {
		this.fraudulentFurndraiserForm = new UntypedFormGroup({
			fullName: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(1),
				Validators.maxLength(200),
				Validators.pattern('^[a-zA-Z ]*$'),
			]),
			email: new UntypedFormControl('', [
				Validators.required,
				Validators.email,
				Validators.pattern(
					'^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'
				),
			]),
			reason: new UntypedFormControl('', [
				Validators.required,
				Validators.minLength(1),
				Validators.maxLength(150),
			]),
		});
	}

	getErrorMessage() {
		return this.fraudulentFurndraiserForm?.controls['email'].hasError(
			'required'
		)
			? $localize`:@@account_registeration_emailIsRequired_mat_error:Email is required`
			: '';
	}

	saveFundraiser() {
		this.fraudulentFurndraiserForm.markAllAsTouched();
		if (this.fraudulentFurndraiserForm.valid) {
			this.isLoading = false;
			let createFraudulentFundraiser: Object;
			createFraudulentFundraiser = {
				name: this.fraudulentFurndraiserForm.get('fullName')?.value,
				email: this.fraudulentFurndraiserForm.get('email')?.value,
				message: this.fraudulentFurndraiserForm.get('reason')?.value,
				slug: this.slug,
			};
			this.fundraiserService
				.markFraudulent(createFraudulentFundraiser)
				.subscribe((response: any) => {
					this.reported = response.data.reported;
				});
		}
	}

	backToFundraiser() {
		this._router.navigate([`/fundraising/${this.slug}`]);
	}
}
